import { SimpleObject } from "../../../../game/types";

export const objects: SimpleObject[] = [];
